import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { getDateToString, getFormatNumber } from '../../../utils/convert';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject } from '../../../utils/helpers';
import { isNull } from '../../../utils/validator';
import DataTaggerModalRedux from '../DataTaggerModalRedux';
import CartelModal from '../CartelModal';
import { useLista } from '../../hooks';
import {TIPS} from "../../../consts/tips";


const CartelesGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      idComercio: 0,
      disabled: false,
      showMessage: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      dataTagger: {
          showModal: false,
          idEntidad: null
      }, 
      list: []
  });

    const dispatch = useDispatch();
    const sequenceValue = useSelector( (state) => state.sequence.value );

    const mount = () => {
        setState(prevState => {
        const list = props.data.list.filter(x => x.state !== 'r');
        return {...prevState,
            idComercio: props.data.idComercio,
            list: list };
        });
    }
    useEffect(mount, [props.data]);

    const [getListLista, getRowLista] = useLista({
        listas: ['TipoProductoPublicitado','TipoCartel','TipoGeoreferencia'],
        onLoaded: (listas, isSuccess, error) => {
          if (isSuccess) {
            setState(prevState => ({...prevState}));
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'TipoProductoPublicitado_TipoCartel_TipoGeoreferencia',
          timeout: 0
        }
    }); 

    const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                    <div onClick={ (event) => handleClickCartelAdd() } className="link">
                                        <span className="material-symbols-outlined" title="Nuevo">add</span>
                                    </div>
                                )}
                              </div>
    const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickCartelView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickCartelModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickCartelRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}
                                  <div onClick={ (event) => handleClickCartelDataTagger(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Información adicional">info</span>
                                  </div>   
                              </div>

    const getDescTipoProductoPublicitado = (id) => {
        const row = getRowLista('TipoProductoPublicitado', id);
        return (row) ? row.nombre : '';
    }
    const getDescTipoCartel = (id) => {
        const row = getRowLista('TipoCartel', id);
        return (row) ? row.nombre : '';
    }

    const tableColumns = [
        { Header: 'Número', accessor: 'numero', width: '10%' },
        { Header: 'Tipo producto publicitado', Cell: (props) => getDescTipoProductoPublicitado(props.value), accessor: 'idTipoProductoPublicitado', width: '25%' },
        { Header: 'Tipo cartel', Cell: (props) => getDescTipoCartel(props.value), accessor: 'idTipoCartel', width: '25%' },
        { Header: 'Alto', Cell: (props) => getFormatNumber(props.value,2), accessor: 'alto', width: '8%' },
        { Header: 'Ancho', Cell: (props) => getFormatNumber(props.value,2), accessor: 'ancho', width: '8%' },
        { Header: 'Superficie', Cell: (props) => getFormatNumber(props.value,2), accessor: 'superficie', width: '8%' },
        { Header: 'Inicio', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaInicio', width: '8%' },
        { Header: 'Baja', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaBaja', width: '8%' },
        { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
    ];

    //handles
    const handleClickCartelAdd = () => {
        const listTipoGeoreferencia = getListLista('TipoGeoreferencia');
        const idTipoGeoreferencia = (listTipoGeoreferencia.length > 0) ? listTipoGeoreferencia[0].id : 530; //el primero u Open Street Map
    
        const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
        setState(prevState => {
            const rowForm = {
                id: idTemporal,
                idComercio: state.idComercio,
                numero: 0,
                idTipoProductoPublicitado: 0,
                idTipoAnuncio: 0,
                idTipoCartel: 0,
                idTipoPropiedad: 0,
                idOrigenDeclaracionJurada: 0,
                idCategoriaUbicacion: 0,
                anuncio: '',
                marquesina: 0,
                cantidadPublicidades: 0,
                fechaInicio: null,
                fechaResolucion: null,
                numeroDDJJ: '',
                fechaDDJJ: null,
                anioDDJJ: '',
                mesDDJJ: 0,
                catastralCir: '',
                catastralSec: '',
                catastralCod: '',
                catastralChacra: '',
                catastralLchacra: '',
                catastralQuinta: '',
                catastralLquinta: '',
                catastralFrac: '',
                catastralLfrac: '',
                catastralManz: '',
                catastralLmanz: '',
                catastralParc: '',
                catastralLparc: '',
                catastralSubparc: '',
                catastralUfunc: '',
                catastralUcomp: '',
                idCuentaInmueble: 0,
                idTasa: 0,
                idSubTasa: 0,
                alto: 0,
                ancho: 0,
                superficie: 0,
                idMotivoBajaComercio: 0,
                fechaBaja: null,
                idBloqueoEmision: 0,
                state: 'a',
                direccion: {
                    id: 0,
                    entidad: "Cartel",
                    idEntidad: idTemporal,
                    idTipoGeoreferencia: idTipoGeoreferencia,
                    idPais: 0,
                    idProvincia: 0,
                    idLocalidad: 0,
                    idZonaGeoreferencia: 0,
                    codigoPostal: "",
                    calle: "",
                    entreCalle1: "",
                    entreCalle2: "",
                    altura: "",
                    piso: "",
                    dpto: "",
                    referencia: "",
                    longitud: 0,
                    latitud: 0,
                    origen: ""
                }
            };
            return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
        });
        dispatch( sequenceActionNext() );
    }

    const handleClickCartelView = (id) => {
        setState(prevState => {
          const rowForm = state.list.find(x => x.id === id);
          return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
        });
    }

    const handleClickCartelModify = (id) => {
        setState(prevState => {
          const rowForm = state.list.find(x => x.id === id);
          return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
        });
    }

    const handleClickCartelRemove = (id) => {
        setState(prevState => {
            const rowForm = state.list.find(x => x.id === id);
            return {...prevState, showMessage: true, rowForm: rowForm};
        });
    }

    const handleClickCartelDataTagger = (id) => {
        setState(prevState => {
          return {...prevState, dataTagger: {showModal: true, idEntidad: id}};
        });
    }    

    //funciones
    function RemoveCartel(row) {
        row.state = 'r';
        props.onChange('Cartel', row);
    }

    function UpdateCartel(row) {
        row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
        props.onChange('Cartel', row);
    }

    return (
    <>

        {state.dataTagger.showModal &&
            <DataTaggerModalRedux
                title="Información adicional de cartel"
                tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_CARTEL_MODAL}
                processKey={props.processKey}
                entidad="Cartel"
                idEntidad={state.dataTagger.idEntidad}
                disabled={props.disabled}
                onDismiss={() => {
                setState(prevState => {
                    return {...prevState, dataTagger: {showModal: false, idEntidad: null}};
                });
                }}
            />
        }

        {state.showMessage && 
            <MessageModal
                title={"Confirmación"}
                message={"¿Está seguro de borrar el registro?"}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showMessage: false, rowForm: null};
                    });
                }}
                onConfirm={() => {
                    const row = CloneObject(state.rowForm);
                    setState(prevState => {
                        return {...prevState, showMessage: false, rowForm: null};
                    });
                    RemoveCartel(row);
                }}
            />
        }

        {state.showForm && 
            <CartelModal
                processKey={props.processKey}
                disabled={!state.modeFormEdit}
                data={{
                    entity: state.rowForm
                }}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowForm: null};
                    });
                }}
                onConfirm={(row) => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowForm: null};
                    });
                    UpdateCartel(row);
                }}
                onMovePrevious={(!state.modeFormEdit && state.rowForm && state.list.length > 1) ? () => {
                    const index = state.list.indexOf(state.list.find(x => x.id === state.rowForm.id));
                    const previousIndex = (index === 0) ? (state.list.length - 1) : (index - 1);
                    const previousId = state.list[previousIndex].id;
                    handleClickCartelView(previousId);
                } : null}
                onMoveNext={(!state.modeFormEdit && state.rowForm && state.list.length > 1) ? () => {
                    const index = state.list.indexOf(state.list.find(x => x.id === state.rowForm.id));
                    const nextIndex = (index === state.list.length - 1) ? 0 : (index + 1);
                    const nextId = state.list[nextIndex].id;
                    handleClickCartelView(nextId);
                } : null}
            />
        }

        <TableCustom
            showFilterGlobal={false}
            className={'TableCustomBase'}
            columns={tableColumns}
            data={ state.list }
        />

    </>
    );
}

CartelesGrid.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onChange: func.isRequired
  };
  
  CartelesGrid.defaultProps = {
    disabled: false
  };

export default CartelesGrid;
